/* eslint-disable no-useless-escape */
export default {
    nameRegex: /^([ÑñA-Za-z- .']{3,100})$/,
    contactNoRegex: /\(\+63\s?\d{1,2}\)\s?\d{4}\s?\d{4}|^[+]639[0-9]{9}$|^(\([0-9]{2,3}\)\s?[0-9]{3}[-\s][0-9]{4}\/)?\([0-9]{2,3}\)[-\s]?[0-9]{3,4}[-\s]?[0-9]{4}$/,
    messageRegex: /^([ÑñA-Za-z0-9 .,!?@#&():\-_\n\r]{30,1000})$/,
};